export default "__VITE_ASSET__CJ$m4ItZ__"